// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/shared/ctxCarousel/ctxCarousel.style.scss
// module id = 145
// module chunks = 0 1